import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FieldDemo from './FieldDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, FieldDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/number-field/demos/field-demo/FieldDemo.tsx",
    "fileName": "FieldDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport NumberField from './NumberField';\n\nexport default function FieldDemo() {\n  return (\n    <Box sx={{ display: 'grid', gap: 4 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <NumberField label=\"Number Field\" min={10} max={40} />\n      <NumberField label=\"Number Field (Small)\" size=\"small\" />\n      <NumberField\n        label=\"Number Field with Error\"\n        min={10}\n        max={40}\n        defaultValue={100}\n        size=\"small\"\n        error\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 20,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport NumberField from './NumberField';\n\nexport default function FieldDemo() {\n  return (\n    <Box sx={{ display: 'grid', gap: 4 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <NumberField label=\"Number Field\" min={10} max={40} />\n      <NumberField label=\"Number Field (Small)\" size=\"small\" />\n      <NumberField\n        label=\"Number Field with Error\"\n        min={10}\n        max={40}\n        defaultValue={100}\n        size=\"small\"\n        error\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "NumberField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Number Field",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "40"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "NumberField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Number Field (Small)",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "NumberField"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Number Field with Error",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "40"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "100"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "error"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 20,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@base-ui/react/number-field",
      "@mui/material/IconButton",
      "@mui/material/FormControl",
      "@mui/material/FormHelperText",
      "@mui/material/OutlinedInput",
      "@mui/material/InputAdornment",
      "@mui/material/InputLabel",
      "@mui/icons-material/KeyboardArrowUp",
      "@mui/icons-material/KeyboardArrowDown"
    ],
    "extraFiles": {
      "NumberField.tsx": {
        "fallback": [
          [
            "span",
            "frame",
            "import * as React from 'react';\nimport { NumberField as BaseNumberField } from '@base-ui/react/number-field';\nimport IconButton from '@mui/material/IconButton';\nimport FormControl from '@mui/material/FormControl';\nimport FormHelperText from '@mui/material/FormHelperText';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport InputAdornment from '@mui/material/InputAdornment';\nimport InputLabel from '@mui/material/InputLabel';\nimport KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';\nimport KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';\n\n/**\n * This component is a placeholder for FormControl to correctly set the shrink label state on SSR.\n */\nfunction SSRInitialFilled(_: BaseNumberField.Root.Props) {\n  return null;\n}\nSSRInitialFilled.muiName = 'Input';\n\nexport default function NumberField({\n  id: idProp,\n  label,\n  error,\n  size = 'medium',\n  ...other\n}: BaseNumberField.Root.Props & {\n  label?: React.ReactNode;\n  size?: 'small' | 'medium';\n  error?: boolean;\n}) {\n"
          ],
          [
            "span",
            "frame",
            {
              "dataFrameType": "focus-unfocused",
              "dataFrameIndent": 0
            },
            "  let id = React.useId();\n  if (idProp) {\n    id = idProp;\n  }\n  return (\n    <BaseNumberField.Root\n      {...other}\n      render={(props, state) => (\n        <FormControl\n          size={size}\n          ref={props.ref}\n          disabled={state.disabled}\n          required={state.required}\n          error={error}\n          variant=\"outlined\"\n        >\n          {props.children}\n        </FormControl>\n      )}\n    >\n      <SSRInitialFilled {...other} />\n      <InputLabel htmlFor={id}>{label}</InputLabel>\n      <BaseNumberField.Input\n        id={id}\n        render={(props, state) => (\n          <OutlinedInput\n            aria-describedby={`${id}-helper-text`}\n            label={label}\n            inputRef={props.ref}\n            value={state.inputValue}\n            onBlur={props.onBlur}\n            onChange={props.onChange}\n            onKeyUp={props.onKeyUp}\n            onKeyDown={props.onKeyDown}\n            onFocus={props.onFocus}\n            slotProps={{\n              input: props,\n            }}\n            endAdornment={\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  flexDirection: 'column',\n                  maxHeight: 'unset',\n                  alignSelf: 'stretch',\n                  borderLeft: '1px solid',\n                  borderColor: 'divider',\n                  ml: 0,\n                  '& button': {\n                    py: 0,\n                    flex: 1,\n                    borderRadius: 0.5,\n                  },\n                }}\n              >\n                <BaseNumberField.Increment\n                  render={<IconButton size={size} aria-label=\"Increase\" />}\n                >\n                  <KeyboardArrowUpIcon\n                    fontSize={size}\n                    sx={{ transform: 'translateY(2px)' }}\n                  />\n                </BaseNumberField.Increment>\n\n                <BaseNumberField.Decrement\n                  render={<IconButton size={size} aria-label=\"Decrease\" />}\n                >\n                  <KeyboardArrowDownIcon\n                    fontSize={size}\n                    sx={{ transform: 'translateY(-2px)' }}\n                  />\n                </BaseNumberField.Decrement>\n              </InputAdornment>\n            }\n            sx={{ pr: 0 }}\n          />\n        )}\n      />\n      <FormHelperText id={`${id}-helper-text`} sx={{ ml: 0, '&:empty': { mt: 0 } }}>\n        Enter value between 10 and 40\n      </FormHelperText>\n    </BaseNumberField.Root>\n  );\n"
          ],
          [
            "span",
            "frame",
            "}\n"
          ]
        ],
        "totalLines": 114,
        "focusedLines": 0,
        "collapsible": true,
        "language": "tsx",
        "source": {
          "type": "root",
          "children": [
            {
              "type": "element",
              "tagName": "span",
              "properties": {
                "className": [
                  "frame"
                ]
              },
              "children": [
                {
                  "type": "text",
                  "value": "import * as React from 'react';\nimport { NumberField as BaseNumberField } from '@base-ui/react/number-field';\nimport IconButton from '@mui/material/IconButton';\nimport FormControl from '@mui/material/FormControl';\nimport FormHelperText from '@mui/material/FormHelperText';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport InputAdornment from '@mui/material/InputAdornment';\nimport InputLabel from '@mui/material/InputLabel';\nimport KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';\nimport KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';\n\n/**\n * This component is a placeholder for FormControl to correctly set the shrink label state on SSR.\n */\nfunction SSRInitialFilled(_: BaseNumberField.Root.Props) {\n  return null;\n}\nSSRInitialFilled.muiName = 'Input';\n\nexport default function NumberField({\n  id: idProp,\n  label,\n  error,\n  size = 'medium',\n  ...other\n}: BaseNumberField.Root.Props & {\n  label?: React.ReactNode;\n  size?: 'small' | 'medium';\n  error?: boolean;\n}) {\n"
                }
              ]
            },
            {
              "type": "element",
              "tagName": "span",
              "properties": {
                "dataFrameType": "focus-unfocused",
                "dataFrameIndent": 0,
                "className": [
                  "frame"
                ]
              },
              "children": [
                {
                  "type": "text",
                  "value": "  let id = React.useId();\n  if (idProp) {\n    id = idProp;\n  }\n  return (\n    <BaseNumberField.Root\n      {...other}\n      render={(props, state) => (\n        <FormControl\n          size={size}\n          ref={props.ref}\n          disabled={state.disabled}\n          required={state.required}\n          error={error}\n          variant=\"outlined\"\n        >\n          {props.children}\n        </FormControl>\n      )}\n    >\n      <SSRInitialFilled {...other} />\n      <InputLabel htmlFor={id}>{label}</InputLabel>\n      <BaseNumberField.Input\n        id={id}\n        render={(props, state) => (\n          <OutlinedInput\n            aria-describedby={`${id}-helper-text`}\n            label={label}\n            inputRef={props.ref}\n            value={state.inputValue}\n            onBlur={props.onBlur}\n            onChange={props.onChange}\n            onKeyUp={props.onKeyUp}\n            onKeyDown={props.onKeyDown}\n            onFocus={props.onFocus}\n            slotProps={{\n              input: props,\n            }}\n            endAdornment={\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  flexDirection: 'column',\n                  maxHeight: 'unset',\n                  alignSelf: 'stretch',\n                  borderLeft: '1px solid',\n                  borderColor: 'divider',\n                  ml: 0,\n                  '& button': {\n                    py: 0,\n                    flex: 1,\n                    borderRadius: 0.5,\n                  },\n                }}\n              >\n                <BaseNumberField.Increment\n                  render={<IconButton size={size} aria-label=\"Increase\" />}\n                >\n                  <KeyboardArrowUpIcon\n                    fontSize={size}\n                    sx={{ transform: 'translateY(2px)' }}\n                  />\n                </BaseNumberField.Increment>\n\n                <BaseNumberField.Decrement\n                  render={<IconButton size={size} aria-label=\"Decrease\" />}\n                >\n                  <KeyboardArrowDownIcon\n                    fontSize={size}\n                    sx={{ transform: 'translateY(-2px)' }}\n                  />\n                </BaseNumberField.Decrement>\n              </InputAdornment>\n            }\n            sx={{ pr: 0 }}\n          />\n        )}\n      />\n      <FormHelperText id={`${id}-helper-text`} sx={{ ml: 0, '&:empty': { mt: 0 } }}>\n        Enter value between 10 and 40\n      </FormHelperText>\n    </BaseNumberField.Root>\n  );\n"
                }
              ]
            },
            {
              "type": "element",
              "tagName": "span",
              "properties": {
                "className": [
                  "frame"
                ]
              },
              "children": [
                {
                  "type": "text",
                  "value": "}\n"
                }
              ]
            }
          ],
          "data": {
            "totalLines": 114,
            "focusedLines": 0,
            "collapsible": true
          }
        }
      }
    }
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
